import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faDiscord,
  faTelegram,
  faGithub,
  faMedium,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="text-white py-10">
      <div className="flex flex-col items-center space-y-4">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <img src="/images/logo/logo.webp" alt="AlphPad" className="h-12 mb-2" />
        </div>

        {/* Social Icons */}
        <div className="flex space-x-4">
          {[
            { href: "https://x.com/alphpad", icon: faTwitter },
            { href: "https://discord.gg/pWy7Y6ase2", icon: faDiscord },
            { href: "https://t.me/alphpad", icon: faTelegram },
            { href: "https://medium.com/@AlphPad", icon: faMedium },
            { href: "https://github.com/AlphPad", icon: faGithub },
          ].map(({ href, icon }, index) => (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-12 h-12 bg-transparent border border-red-500 rounded-md hover:bg-red-500 transition"
            >
              <FontAwesomeIcon icon={icon} className="w-6 h-6" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
